import { render } from "./DoctorsListTemplate1.vue?vue&type=template&id=1e76aba9&scoped=true"
import script from "./DoctorsListTemplate1.vue?vue&type=script&lang=ts"
export * from "./DoctorsListTemplate1.vue?vue&type=script&lang=ts"

import "./DoctorsListTemplate1.vue?vue&type=style&index=0&id=1e76aba9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1e76aba9"

export default script